import { Box } from '../../common/ui/Box';

export const BunkerPlanDot = () => {
    return <Box height="4px" width="4px" borderRadius="100%" backgroundColor="accent.foreground" />;
};
